import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import ContactForm from '../components/forms/ContactForm'
import { PageFactory } from './Page'
import PersonToContactInput from '../components/forms/_PersonToContactInput'

const BasePost = PageFactory({
  renderers: {
    ContactForm: props => (
      <ContactForm {...props} ContactInputComponent={PersonToContactInput} />
    ),
  },
})

const Contact = props => <BasePost {...props} which="contact" />

const ContactRoutable = withRouter(props => (
  <Switch>
    <Route path="/contact/:contactID" component={Contact} />
    <Route path="/contact" component={Contact} />
  </Switch>
))

export default ContactRoutable
